import * as moment from 'moment';

enum BillingFrequency {
  YEARLY = 'YEARLY',
  MONTHLY = 'MONTHLY',
}

const frequencyText = {
  perWhen: {
    YEARLY: 'settings:account:plan:perYear',
    MONTHLY: 'settings:account:plan:perMonth',
  },
  billedWhen: {
    YEARLY: 'settings:account:plan:billedYearly',
    MONTHLY: 'settings:account:plan:billedMonthly',
  },
  sliderOptions: {
    uppercase: {
      YEARLY: 'settings:plans:adjust:pro:slider:frequencyOptions:uppercase:year',
      MONTHLY: 'settings:plans:adjust:pro:slider:frequencyOptions:uppercase:month',
    },
    lowercase: {
      YEARLY: 'settings:plans:adjust:pro:slider:frequencyOptions:lowercase:year',
      MONTHLY: 'settings:plans:adjust:pro:slider:frequencyOptions:lowercase:month',
    },
  },
};

// Incomplete, fill in as necessary
type JSONPlan = {
  is_pro: boolean;
  is_full_access: boolean;
  is_subscription: boolean;
  display_name: string;
  name: string;
  is_free_trial: boolean;
  frequency: string;
  subscription_price: string;
  original_subscription_price: string;
  number_of_labels_included: number;
  number_of_seats: number;
};

type Plan = {
  // TODO: Deprecate isPro
  isPro: boolean;
  isFullAccess: boolean;
  displayName: string;
  name: string;
  isFreeTrial: boolean;
  billingFrequency: string;
  subscriptionPrice: number;
  originalSubscriptionPrice: number;
  numberOfLabelsIncluded: number;
  numberOfSeats: number;
};

export type JSONUserPlan = {
  plan: JSONPlan;
  start_date: string;
  end_date: Maybe<string>;
  next_billing_date: Maybe<string>;
};

type UserPlan = {
  plan: Plan;
  startDate: moment.Moment;
  endDate: Maybe<moment.Moment>;
  nextBillingDate: Maybe<moment.Moment>;
};

function fromJSON(jsonPlan: JSONPlan): Plan {
  return {
    isPro: jsonPlan.is_pro,
    isFullAccess: jsonPlan.is_full_access,
    displayName: jsonPlan.display_name,
    name: jsonPlan.name,
    isFreeTrial: jsonPlan.is_free_trial,
    billingFrequency: jsonPlan.frequency,
    subscriptionPrice: Number(jsonPlan.subscription_price),
    originalSubscriptionPrice: Number(jsonPlan.original_subscription_price),
    numberOfLabelsIncluded: jsonPlan.number_of_labels_included,
    numberOfSeats: jsonPlan.number_of_seats,
  };
}

function userPlanFromJSON(jsonUserPlan: JSONUserPlan): UserPlan {
  return {
    plan: fromJSON(jsonUserPlan.plan),
    startDate: moment(jsonUserPlan.start_date),
    endDate: jsonUserPlan.end_date ? moment(jsonUserPlan.end_date) : null,
    nextBillingDate: jsonUserPlan.next_billing_date ? moment(jsonUserPlan.next_billing_date) : null,
  };
}

export default Plan;

export { UserPlan, fromJSON, userPlanFromJSON, BillingFrequency, frequencyText };
